import React from 'react';

const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

const getBytes = (bytes: number) => {
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return (!bytes && '0 Bytes') || Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
};

type BytesProps = {
  bytes: number;
};
export const Bytes: React.FC<BytesProps> = ({ bytes }) => {
  return <span>{getBytes(bytes)}</span>;
};
